import React from "react";
import styled from "styled-components";

import "./Loader.css";

export default ({ loaded }) => {
  return (
    <LoaderWrapper className={loaded && "d-none"}>
      <div className="dr-loader" />
    </LoaderWrapper>
  );
};

const LoaderWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    border-radius: 10px;

    .dr-loader {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -20px;
        margin-top: -20px;
    }
`